import { isBrowser } from "../../../common/helpers/env";
import store from "store";

export const saveStoreValue = (value: number) => {
    if (!isBrowser) return;
    store.set("supportWarning", value.toString());
};

export const getStoreValue = () => {
    if (!isBrowser) return;
    return +(store.get("supportWarning") || 0);
};
